<script setup lang="ts">
import { defineProps } from 'vue'
const props = defineProps({
  hero:{}
})
</script>

<template>
  <div class="impx-slide-container hp9 uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom uk-background-fixed uk-background-center-center uk-height-1-1">
    <div class="impx-overlay dark"></div>
    <div class="uk-container uk-margin-top impx-margin-top-small">
      <div class="uk-width-1-1" style="height: 560px !important;">
        <div class="uk-flex uk-flex-left uk-position-bottom uk-margin-left uk-margin-bottom">
          <div class="uk-light uk-position-relative uk-text-left page-title">
            <h1 class="uk-margin-remove">{{props.hero?.title}}</h1><!-- page title -->
            <p class="impx-text-large uk-margin-remove">{{props.hero?.subtitle}}</p><!-- page subtitle -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>